// extracted by mini-css-extract-plugin
export default {"country_client_pricing_rule_card":"styles_country_client_pricing_rule_card__FmSoq"};